import { Component } from '@angular/core';

@Component({selector: 'app-interactive-guide',
  templateUrl: './interactive-guide.component.html',
  styleUrls: ['./interactive-guide.component.scss'],
  standalone: false,
})
export class InteractiveGuideComponent {


}
